import { Stack, Typography, useTheme } from "@mui/material";
import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BuildingAreaAndDateFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingAreaAndDateFields";
import { BuildingClassificationFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingClassificationFields";
import { BuildingExtendedParams } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingExtendedParams";
import { BuildingIdentityFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingIdentityFields";
import { BuildingParameterFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingParameterFields";
import { BuildingValueFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingValueFields";
import {
	type BuildingFormInput,
	type BuildingFormOutput,
	buildingMinimumGroup,
} from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";
import { RealEstateTypeRow } from "web_myplann/Portfolio/Forms/RealEstateForm/RealEstateTypeRow";
import type {
	BuildingRealEstateType,
	RealEstateType,
} from "web_myplann/Portfolio/Forms/RealEstateForm/realEstateTypes";
import { RequiredMinimumMessage } from "web_myplann/Portfolio/PortfolioShared/RequiredMinimumMessage";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";

type Props = {
	control: Control<BuildingFormInput, unknown, BuildingFormOutput>;
	type: BuildingRealEstateType;
	onTypeChange: (type: RealEstateType) => void;
};

const FormResources = Resources.Portfolio.AddRealEstate;

export const BuildingCreateFormFields = ({
	control,
	type,
	onTypeChange,
}: Props) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<>
			<Typography variant="sectionLabel">
				{t(FormResources.Sections.basicInfo)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<RealEstateTypeRow mode="select" value={type} onChange={onTypeChange} />
				<FlatRowFormInput
					control={control}
					name="name"
					label={t(FormResources.Fields.name)}
					placeholder={t(FormResources.Placeholders.fill)}
				/>
				<BuildingIdentityFields control={control} />
				<BuildingAreaAndDateFields control={control} />
				<BuildingExtendedParams disclosurePlacement="bottom">
					<BuildingParameterFields control={control} type={type} />
				</BuildingExtendedParams>
			</Stack>
			<RequiredMinimumMessage
				control={control}
				fields={buildingMinimumGroup}
				message={t(FormResources.Validations.requiredMinimum)}
			/>

			<Typography variant="sectionLabel">
				{t(FormResources.Sections.values)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<BuildingValueFields control={control} isLast />
			</Stack>

			<BuildingClassificationFields control={control} />
		</>
	);
};
